import { Component, OnInit } from '@angular/core';
import { User } from '../../models/User';
import { WorkerService } from '../../services/entities/worker.service';
import { DateService } from '../../services/date.service';
import { UserService } from '../../services/entities/user.service';
import { TransalateService } from '../../services/transalate.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss'
})
export class UsersComponent implements OnInit {

  constructor(public dateService: DateService,
              public translateService: TransalateService,
              private userService: UserService,
              ){}

  //Modal Vars
  delete_modal: boolean = false
  modal_delete_checkbox: boolean = false
  delete_user: User = {id: '', email: '', role: ''}

  update_password_modal: boolean = false
  update_user_password: {id: string, password: string} = {id: '', password: ''}

  //Orders Vars
  users: User[] = []

  async ngOnInit() {
    this.users = (await this.userService.getUsers().toPromise())!!
    this.sortOrders()
  }

  sortOrders(){
    this.users = this.users.sort((a, b) => a.email.localeCompare(b.email))
  }

  closeUpdatePasswordModal(){
    this.update_password_modal = false
    this.update_user_password = {id: '', password: ''}
  }

  openUpdateUserPasswordModal(user: User){
    this.update_user_password = {id: user.id, password: ''}
    this.update_password_modal = true
  }

  updateUserPassword(){
    this.userService.updateUserPassword(this.update_user_password.id, this.update_user_password.password).subscribe(
      () => {
        this.closeUpdatePasswordModal()
      },
      error => {
        console.error('Error updating user password', error)
      }
    )
  }

  closeDeleteModal(){
    this.delete_modal = false
    this.delete_user = {id: '', email: '', role: ''}
    this.modal_delete_checkbox = false
  }

  openDeleteModal(user: User){
    this.delete_user = user
    this.modal_delete_checkbox = false
    this.delete_modal = true
  }

  deleteUser(){
    this.userService.deleteUserById(this.delete_user.id).subscribe(
      () => {
        this.users = this.users.filter(user => user.id !== this.delete_user.id)
        this.closeDeleteModal()
      },
      error => {
        console.error('Error deleting user', error)
      }
    )
  }
}
